import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Logger from '@autobest-ui/client-logger';
import Ajax from '@autobest-ui/ajax';
import ajaxInterceptor from './utils/ajaxInterceptor';
import configureStore from './store';
import RenderRoutes from './components/renderRoutes';
import routes from './routes';
import getRunEnv from './utils/env';
import '@autobest-ui/components/lib/style.css';
import '@autobest-ui/icon/esm/style.css';
import './assets/styles/app.scss';
import UseConfig from './utils/UseConfig';

declare global {
  interface Window {
    gtag: any;
    WebKitMutationObserver?: typeof MutationObserver;
    MozMutationObserver?: typeof MutationObserver;
  }
}

const runEnv = getRunEnv();

let assetSupportWebP = false;
try {
  assetSupportWebP =
    document
      .createElement('canvas')
      .toDataURL('image/webp', 0.5)
      .indexOf('data:image/webp') === 0;
  // eslint-disable-next-line no-empty
} catch {}

// 配置公共组件库静态资源链接
UseConfig.setConfig({
  assetCommonUiUrl: `${runEnv.AssetServiceUrl}/common-uiasset`,
  assetOfficialUrl: runEnv.AssetServiceUrl,
  WWWServiceUrl: runEnv.ApiServiceUrl,
  assetSupportWebP
});

const store = configureStore({
  initApp: {}
});

ajaxInterceptor(Ajax, {
  config: {
    baseUrl: runEnv.ApiServiceUrl,
    requestConfig: {
      headers: {
        // 全局header
      }
    },
    timeout: 70000
  },
  store,
  logger: Logger
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <RenderRoutes routes={routes} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
